import Swiper from 'swiper';
import { Navigation, Autoplay } from 'swiper/modules';
import { mediaQueryBreakpointMD, mediaQueryBreakpointSM } from '../Utils/Utils';
Swiper.use([Navigation, Autoplay]);

const TrustpilotReviews = (blockElem) => {

	//
	// Set up the slideshow
	new Swiper(blockElem.querySelector('.swiper'), {
		direction: 'horizontal',
		slidesPerView: 1,
		centeredSlides: false,
		autoplay: {
			delay: 3000,
		},
		loop: true,

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		breakpoints: {
			[mediaQueryBreakpointSM]: {
				slidesPerView: 2,
				loop: true,
				spaceBetween: (blockElem.querySelectorAll('.swiper-slide').length > 1 ? 20 : 0),
			},
			[mediaQueryBreakpointMD]: {
				slidesPerView: 4,
				loop: true,
				spaceBetween: (blockElem.querySelectorAll('.swiper-slide').length > 1 ? 20 : 0),
			},
		}
	});
};

export default TrustpilotReviews;